module.exports = __webpack_public_path__ + "static/media/fix.19423a89.svg";